import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormInput } from "go-form";
import { getCurrencies, getTimezones } from "go-core/utils/utils";
import { FormSelectGroup } from "go-form/components/FormSelect";
import { OrganizationApi } from "../../../../../../../../../../../services/Api/types";

interface Props {
	form: UseFormReturn<OrganizationApi>;
}

const OrganizationContactForm = ({ form }: Props) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
		control,
	} = form;
	const currencyOptions = getCurrencies();
	const timezoneOptions = getTimezones()
		.sort()
		.map((zone) => {
			return { label: zone, value: zone };
		});

	return (
		<>
			<div className="row row-cols-md-2">
				<div className="col-md-6">
					<FormInput
						label={t("modules.settings.field.website.title")}
						name="place.website"
						errors={errors}
						register={register}
					/>
				</div>
				<div className="col-md-6">
					<FormSelectGroup
						label={t("modules.settings.field.currency.title")}
						name="currency"
						errors={errors}
						options={currencyOptions}
						control={control}
						data-testid="currency"
					/>
				</div>
			</div>
			<div className="row row-cols-md-2">
				<div className="col-md-6">
					<FormSelectGroup
						label={t("modules.settings.field.timezone.title")}
						name="timezone"
						errors={errors}
						control={control}
						options={timezoneOptions}
						data-testid="timezone"
					/>
				</div>
				<div className="col-md-6">
					<Form.Label>{t("modules.settings.field.facebook.title")}</Form.Label>
					<InputGroup className="form-input-group">
						<InputGroup.Text style={{ height: "31px" }}>fb.com/</InputGroup.Text>
						<FormInput
							name="place.facebook"
							errors={errors}
							register={register}
							style={{ borderRadius: "0 4px 4px 0" }}
						/>
					</InputGroup>
				</div>
			</div>
			<div className="row row-cols-md-2">
				<div className="col-md-6">
					<Form.Label>{t("modules.settings.field.instagram.title")}</Form.Label>
					<InputGroup className="form-input-group">
						<InputGroup.Text style={{ height: "31px" }}>instagram.com/</InputGroup.Text>
						<FormInput
							name="place.instagram"
							errors={errors}
							register={register}
							style={{ borderRadius: "0 4px 4px 0" }}
						/>
					</InputGroup>
				</div>
				<div className="col-md-6">
					<Form.Label>{t("modules.settings.field.linkedin.title")}</Form.Label>
					<InputGroup className="form-input-group">
						<InputGroup.Text style={{ height: "31px" }}>linkedin.com/company/</InputGroup.Text>
						<FormInput
							name="place.linkedin"
							errors={errors}
							register={register}
							style={{ borderRadius: "0 4px 4px 0" }}
						/>
					</InputGroup>
				</div>
			</div>
		</>
	);
};

export default OrganizationContactForm;
